module.exports = {
  ...require('./dom'),
  ...require('./logging'),
  ...require('./performance'),
  ...require('./masterPageUtils'),
  ...require('./data'), //when importing methods from this folder in sites backend we need to import it as follows:  import {methodName} from '@hisense-staging/velo-npm/backend'
  ...require('./product'), //same here for methods inside product/data if we want to use it in backend
  ...require('./custom-elements'),
  ...require('./consts'),
  ...require('./hubspotFormUtils'),
  ...require('./paramsHandler'),
  ...require('./preview'),
  ...require('./qa'),
};
